module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_tohoku-b93e3ec0eafa233adc800e303e1d29e4.png";